"use client";
import { useState } from "react";

export default function CustomTripForm() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    people: "",
    idea: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.currentTarget;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    const payload = {
      name: form.name,
      email: form.email,
      phone: form.phone,
      people_count: Number(form.people),
      message: form.idea,
    };

    try {
      const res = await fetch("https://cms.travelalvaro.sk/form/custom-tour", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status === "ok") {
        fetch("/api/form/custom-tour", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        setSubmitted(true);
      } else {
        alert("Chyba pri odosielaní: " + data.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Chyba pri odosielaní formulára. Skúste to prosím znovu.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className='mt-8 text-center'>
        <h2 className='text-2xl font-bold mb-2'>Ďakujeme!</h2>
        <p>Vaša požiadavka bola úspešne odoslaná. Ozveme sa do 48 hodín.</p>
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className='bg-[#F5F5F5] rounded-xl p-6 text-left max-w-xl w-full mx-auto mb-20'
    >
      <div className='mb-4'>
        <label className='block mb-1 font-semibold' htmlFor='name'>
          Meno*
        </label>
        <input
          id='name'
          name='name'
          type='text'
          value={form.name}
          onChange={handleChange}
          required
          className='border border-[#D9D9D9] bg-white rounded-md p-2 w-full'
          placeholder='Zadaj svoje meno'
        />
      </div>
      <div className='mb-4'>
        <label className='block mb-1 font-semibold' htmlFor='phone'>
          Telefónne číslo*
        </label>
        <input
          id='phone'
          name='phone'
          type='tel'
          value={form.phone}
          onChange={handleChange}
          required
          className='border border-[#D9D9D9] bg-white rounded-md p-2 w-full'
          placeholder='Zadaj svoje telefónne číslo'
        />
      </div>
      <div className='mb-4'>
        <label className='block mb-1 font-semibold' htmlFor='email'>
          Email*
        </label>
        <input
          id='email'
          name='email'
          type='email'
          value={form.email}
          onChange={handleChange}
          required
          className='border border-[#D9D9D9] bg-white rounded-md p-2 w-full'
          placeholder='Zadaj svoj email'
        />
      </div>
      <div className='mb-4'>
        <label className='block mb-1 font-semibold' htmlFor='people'>
          Počet osôb*
        </label>
        <input
          id='people'
          name='people'
          type='number'
          min='1'
          value={form.people}
          onChange={handleChange}
          required
          className='border border-[#D9D9D9] bg-white rounded-md p-2 w-full'
          placeholder='Zadaj počet osôb'
        />
      </div>
      <div className='mb-4'>
        <label className='block mb-1 font-semibold' htmlFor='idea'>
          Vaša predstava o výlete a destináciach*
        </label>
        <textarea
          id='idea'
          name='idea'
          value={form.idea}
          onChange={handleChange}
          required
          rows={5}
          className='border border-[#D9D9D9] bg-white rounded-md p-2 w-full'
          placeholder='Opíš svoju predstavu, destinácie, aktivity...'
        />
      </div>
      <button
        type='submit'
        disabled={loading}
        aria-busy={loading}
        className='bg-[#619F1C] text-white cursor-pointer text-sm py-3 rounded-full font-semibold hover:bg-[#c65c1e] transition w-full disabled:opacity-60 disabled:cursor-not-allowed'
      >
        {loading ? (
          <span className='flex items-center justify-center gap-2'>
            <svg
              className='animate-spin h-4 w-4 text-white'
              viewBox='0 0 24 24'
            >
              <circle
                className='opacity-25'
                cx='12'
                cy='12'
                r='10'
                stroke='currentColor'
                strokeWidth='4'
              ></circle>
              <path
                className='opacity-75'
                fill='currentColor'
                d='M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z'
              ></path>
            </svg>
            Odosielam...
          </span>
        ) : (
          "Odoslať požiadavku"
        )}
      </button>
    </form>
  );
}
